import { Box, Stack } from '@mui/material'
import { MetricTimelineItemReadingTime } from 'features/Metric/components/MetricTimelineItemReadingTime/MetricTimelineItemReadingTime'
import { UIItemContentContainer, UIStatusBadge } from 'features/UI'
import { ReactNode } from 'react'
import { ETimelinePostStatus } from 'types'
import { TimelineItemHeader } from '../TimelineItemHeader/TimelineItemHeader'

export function TimelineItemCard({
  title,
  status,
  commentControl,
  controls,
  readingTime,
  bannerUrl,
  onClick,
}: {
  controls: ReactNode | null
  title: string
  status: ETimelinePostStatus
  readingTime?: number
  bannerUrl?: string | null
  onClick: () => void
  commentControl?: ReactNode
}) {
  return (
    <UIItemContentContainer onClick={onClick}>
      <TimelineItemHeader title={title} showAvatar bannerUrl={bannerUrl} hideBorderBottom />

      <Stack direction="row" gap={1} alignItems="center">
        <Stack
          gap={1}
          flexGrow={1}
          sx={{
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'flex-start', sm: 'align-center' },
          }}
        >
          <UIStatusBadge status={status} />

          <MetricTimelineItemReadingTime readingTime={readingTime} />

          {commentControl}
        </Stack>

        <Box minWidth="64px">{controls}</Box>
      </Stack>
    </UIItemContentContainer>
  )
}
